<template>
  <v-dialog v-model="estado_dialog" width="500" persistent>
    <v-card>
      <v-card-title> Aseguradora CONTINENTAL </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <v-text-field
                v-model="n_caso"
                label="Numero caso"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="n_caso_dis && !puedeEditar"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="cerrarDialog()">Cerrar</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="validarId()"
          v-if="puedeEditar || campos_completos"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: true,
      id_cierre_continental: 0,
      n_caso: "",
      estatus_asistencia: "",
      rule: [(v) => !!v || "Campos obligatorios"],
      campos_completos: true,
      ////
      n_caso_dis: false,
    };
  },
  computed: {
    puedeEditar() {
      return (
        this.$store.state.usuario.rol == "Team Leader Cabina" ||
        this.$store.state.usuario.rol == "Administrador"
      );
    },
  },
  props: ["estado_dialog", "id_cabina"],
  methods: {
    listarDatos(estatus_asistencia) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      this.estatus_asistencia = estatus_asistencia;

      axios
        .get("api/CierreContiental/Listar/" + this.id_cabina, configuracion)
        .then((response) => {
          if (response.data.length > 0) {
            this.id_cierre_continental = response.data[0].id_cierre_continental;
            this.n_caso = response.data[0].caso;

            if (
              this.$store.state.usuario.idUsuario == 1 ||
              this.$store.state.usuario.idUsuario == 5 ||
              this.$store.state.usuario.idUsuario == 1007 ||
              this.$store.state.usuario.idUsuario == 1009 ||
              this.$store.state.usuario.idUsuario == 1011
            ) {
              return;
            }

            if (this.n_caso.length > 0) {
              this.campos_completos = false;
            }

            if (this.n_caso.length > 0) {
              this.n_caso_dis = true;
            }
          }
        });
    },
    validarId() {
      if (this.id_cierre_continental == 0) {
        this.crearRegistro();
      } else if (this.id_cierre_continental > 0) {
        this.actualizarRegistro();
      }
    },
    crearRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/CierreContiental/Crear",
          {
            idCabina: this.id_cabina,
            caso: this.n_caso,
          },
          configuracion,
        )
        .then(() => {
          this.cerrarDialog();
        });
    },
    actualizarRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.estatus_asistencia == "FINALIZADO") {
        if (this.$refs.form.validate()) {
          axios
            .put(
              "api/CierreContiental/Actualizar",
              {
                id_cierre_continental: this.id_cierre_continental,
                idCabina: this.id_cabina,
                caso: this.n_caso,
              },
              configuracion,
            )
            .then(() => {
              this.cerrarDialog();
            });
        }
      } else {
        axios
          .put(
            "api/CierreContiental/Actualizar",
            {
              id_cierre_continental: this.id_cierre_continental,
              idCabina: this.id_cabina,
              caso: this.n_caso,
            },
            configuracion,
          )
          .then(() => {
            this.cerrarDialog();
          });
      }
    },
    cerrarDialog() {
      this.$emit("update:estado_dialog", !this.estado_dialog);
      this.id_cierre_continental = 0;
      this.n_caso = "";
      this.$refs.form.resetValidation();
    },
  },
};
</script>
